import React ,{useContext, useEffect,useRef,useState} from 'react'
import noteContext from '../Context/Notes/noteContext'
import NoteItem from './NoteItem';
import AddNotes from './addNotes';
import { useNavigate } from 'react-router-dom';
import './noteItem.css'

const Notes = (props) => {
     const context = useContext(noteContext);
     const {notes,getNotes,updateNotes} = context;
     let navigate = useNavigate();
     useEffect(()=>{
        if(localStorage.getItem("token")){
            getNotes()
        }

    else{
        navigate("/login")

    }
        // eslint-disable-next-line
     },[])


     const ref = useRef(null)
     const refClose = useRef(null)
     const [note, setNote] = useState({id:"",  etitle:"",edescription:"",etag:""})


     const updateNote = (currentNote) =>{
      ref.current.click();
      setNote({id:currentNote._id, etitle:currentNote.title, edescription:currentNote.description, etag:currentNote.tag })
     }

     const handleClick = (e) =>{
      console.log("Updating the Note");
      updateNotes(note.id, note.etitle, note.edescription, note.etag);
      refClose.current.click(); // Add this line to close the modal
      e.preventDefault();
      props.showAlert("Updated Successfully", "success")

    }
    

  const onChange = (e) =>{
      setNote({...note, [e.target.name]:e.target.value})    
  }

  return (
    <>
      <AddNotes showAlert={props.showAlert}/>
      <button ref={ref} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
        Launch demo modal
      </button>
      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Edit Note</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form className="my-3">
                <div className="mb-3">
                  <label htmlFor="title" className="form-label">Title</label>
                  <input type="text" className="form-control" id="etitle" name="etitle" value={note.etitle} aria-describedby="emailHelp" onChange={onChange}  minLength={3} required />
                </div>
                <div className="mb-3">
                  <label htmlFor="description" className="form-label">Description</label>
                  <input type="text" className="form-control" id="edescription" name="edescription" value={note.edescription} onChange={onChange}  minLength={3} required/>
                </div>
                <div className="mb-3">
                  <label htmlFor="tag" className="form-label">Tag</label>
                  <input type="text" className="form-control" id="etag" name="etag" value={note.etag} onChange={onChange} />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button  ref={refClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button disabled={note.etitle.length < 3 || note.edescription.length < 3} onClick={handleClick} type="button" className="btn btn-primary">Update Note</button>
            </div>
          </div>
        </div>
      </div>
      <div className='container row my-3 '>
        <h2>Your Notes</h2>
        <div className='container my-2 mx-2'>
          {Array.isArray(notes) && notes.length === 0 && `No notes to display`}
        </div>
        {Array.isArray(notes) ?
          notes.map((note) => {
            return <NoteItem key={note._id} Notes={note} updateNote={updateNote} showAlert={props.showAlert} />
          })
          :
          <p>No notes to display</p>
        }
      </div>
    </>
  )
  
}

export default Notes